import axios from 'axios'
import Vue from 'vue';
axios.defaults.withCredentials = true
export default new function httpClients() {
  this.host = 'https://www.ids2024.com/api'

  this.protocol = {
    login: this.host + '/LoginApi/login', // 登录
    register: this.host + '/LoginApi/register', // 注册
    uploadFile: this.host + "/VisApi/uploadFile", // 文件上传
    add_report: this.host + '/H5Api/add_report', // 上传资料
    upload_report: this.host + '/H5Api/upload_report', // 修改上传资料
    report_list: this.host + '/H5Api/report_list', // 资料列表
    delete_report: this.host + '/H5Api/delete_report', // 删除资料列表
    get_info: this.host + '/H5Api/show_register',//查看注册信息
    update_register: this.host + '/H5Api/update_register',// 补全注册个人信息（最新）
    update_register_Payment: this.host + "/H5Api/update_register_Payment",// 补全注册付款信息（最新）
  };



  this.update_register_Payment = function (params) { // 补全注册付款信息（最新）
    return this.post(this.protocol.update_register_Payment, params)
  }
  this.update_register = function (params) { // 补全注册个人信息（最新）
    return this.post(this.protocol.update_register, params)
  }
  this.login = function (params) { // 登录
    return this.post(this.protocol.login, params)
  }
  this.get_info = function (params) { // 查看注册信息
    return this.get(this.protocol.get_info, params)
  }
  this.register = function (params) { // 注册
    return this.post(this.protocol.register, params)
  }
  this.uploadFile = function (params) { // 文件上传
    return this.post(this.protocol.uploadFile, params)
  }
  this.add_report = function (params) { // 上传资料
    return this.post(this.protocol.add_report, params)
  }
  this.upload_report = function (params) { // 修改上传资料
    return this.post(this.protocol.upload_report, params)
  }
  this.report_list = function (params) { // 修改上传资料
    return this.post(this.protocol.report_list, params)
  }
  this.delete_report = function (params) { // 修改上传资料
    return this.post(this.protocol.delete_report, params)
  }



  this.get_token_list = function (symbols) {
    let wallets = {};
    return this.get_assets().then(result => {
      if (result.code === 200) {
        for (let i = 0; i < result.data.length; ++i) {
          let item = result.data[i];
          wallets[item.symbol] = item;
        }
        return this.get_rate({
          orgCoin: symbols,
          targetCoin: "GBP"
        });
      }
      return result;
    }).then(result => {
      if (result.code === 200) {
        let rates = {};
        for (let i = 0; i < result.data.length; ++i) {
          let item = result.data[i];
          rates[item.orgCoin] = item;
        }
        return {
          code: 200,
          wallets,
          rates
        };
      }
      return result;
    });
  };

  this.to_withdraw = function (params) {
    params.fromId = Vue.prototype.$config.getUser().uuid;
    return this.post(this.protocol.to_withdraw, params);
  };

  function query(key, data) {
    if (Array.isArray(data)) {
      let r = [];
      data.forEach(str => {
        if (str) {
          r.push(encodeURIComponent(key) + '[]=' + encodeURIComponent(str))
        }
      });
      return r.join("&");
    }
    return encodeURIComponent(key) + '=' + encodeURIComponent(data);
  }

  function queryString(params) {

    return '?' + Object.keys(params).map(function (key) {
      return query(key, params[key]);
    }).join("&");
  }

  function noqueryString(params) {
    return Object.values(params).join('/');
  }

  this.sendGet = function (url) {
    return axios({
      url: url,
      type: 'GET',
      dataType: 'json',
      crossDomain: true,
      baseURL: "https://www.ids2024.com/",
      xhrFields: {
        withCredentials: true
      },
      contentType: "multipart/json",
      // headers: {
      //   contentType: "application/json"
      // }
      //this.getHeaders()
    })
      .then(response => {
        return response.data;
      })
  };
  this.getHeaders = function () {
    let sign = Vue.prototype.$config.getSignature();
    if (sign) {
      return {
        'access-key': sign.access_key,
        'nonce': sign.nonce,
        'signature': sign.signature,
        'timestamp': sign.timestamp
      };
    } else {
      return {}
    }
  };
  this.upload = function (url, params) {
    return axios({
      method: "POST",
      url: url,
      crossDomain: true,
      baseURL: "https://www.ids2024.com/",
      xhrFields: {
        withCredentials: true
      },
      data: this.formData(params),
      contentType: "multipart/form-data",
    }).then(res => {
      return res.data;
    }).catch(err => {
      return err;
    })
  };
  this.sendPost = function (url, options) {
    return axios({
      method: "POST",
      url: url,
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      },
      data: options,
      contentType: "application/json",
      // headers: this.getHeaders()
    }).then(res => {
      return res.data;
    }).catch(err => {
      return err;
    })
  };
  this.put = function (url, data) {
    return axios({
      method: "PUT",
      url: url,
      data: data,
      baseURL: "https://www.ids2024.com/",
      contentType: "application/json",
      // headers: this.getHeaders()
    }).then(res => {
      return res.data;
    }).catch(err => {
      return err;
    })
  };
  this.formData = function (params) {
    if (typeof params === "object") {
      let formData = new FormData();
      let postDataInstances = [ArrayBuffer, Blob, Document, FormData, File];
      for (let key in params) {
        if (params[key] && typeof params[key] === 'object' && postDataInstances.indexOf(params[key].constructor) === -1) {
          formData.append(key, JSON.stringify(params[key]));
        } else {
          formData.append(key, params[key]);
        }

      }
      return formData;
    }
    return params;
  };
  this.get = function (url, params) {
    if (typeof params !== "object") {
      return this.sendGet(url);
    } else {
      if (params.mode === 'noquery') {
        delete params.mode;
        return this.sendGet(url + noqueryString(params));
      } else {
        return this.sendGet(url + queryString(params));
      }
    }
  };
  this.post = function (url, params) {
    return this.sendPost(url, params);
  };


}


// WEBPACK FOOTER //
// ./src/utils/http.js